import { Button, PrimaryButton } from '../../components/Base';

const NoCard = () => {
  return (
    <p>
      No card on file.
      <br />
      <PrimaryButton type={Button.TYPE_ROUTE} to="/checkout" size="small">
        Go Premium
      </PrimaryButton>
    </p>
  );
};

export default NoCard;
